module.exports = __webpack_public_path__ + "img/wa2.3b79c807.jpg";